import React from "react";
import { Button, Icon } from "../..";

const WidgetTypeCard = ({ widget, isSelected, onSelect }) => {
  return (
    <Button
      type="button"
      variant="outline"
      size="touch"
      onClick={onSelect}
      aria-pressed={isSelected}
      className={`ordering-widget-type-card relative h-full w-full items-start justify-start rounded-lg border p-5 text-start whitespace-normal ${
        isSelected
          ? "border-primary bg-accent"
          : "border-border hover:border-primary hover:bg-accent"
      } `}
    >
      {widget.popular && (
        <span className="bg-primary text-primary-foreground absolute -end-2 -top-2 rounded-md px-2 py-0.5 text-xs font-medium">
          Popular
        </span>
      )}

      <div
        className={`mb-4 flex h-12 w-12 items-center justify-center rounded-md ${isSelected ? "bg-primary" : "bg-accent"} `}
      >
        <Icon
          name={widget.icon}
          className={`h-6 w-6 ${isSelected ? "text-white" : "text-muted-foreground"}`}
        />
      </div>

      <h3 className="text-card-foreground mb-2 font-semibold">{widget.name}</h3>
      <p className="text-muted-foreground mb-4 text-sm">{widget.description}</p>

      <div className="flex flex-wrap gap-2">
        {widget.features.map((feature, index) => (
          <span
            key={index}
            className="bg-accent text-muted-foreground rounded-md px-2 py-1 text-xs"
          >
            {feature}
          </span>
        ))}
      </div>

      {isSelected && (
        <div className="absolute end-4 top-4">
          <div className="bg-primary flex h-6 w-6 items-center justify-center rounded-full">
            <Icon name="Check" className="h-4 w-4 text-white" />
          </div>
        </div>
      )}
    </Button>
  );
};

export default WidgetTypeCard;
